module.exports = __webpack_public_path__ + "img/background.048d49ff.png";